import {Component} from "@angular/core";
import {MatBottomSheetRef} from "@angular/material/bottom-sheet";

@Component({
    selector: 'botoes-relatorios',
    templateUrl: 'botoes-relatorio.html',
})
export class BotoesRelatorioRimComponent {
    constructor(private botoesRelatorioRef: MatBottomSheetRef<BotoesRelatorioRimComponent>) {
    }

    selecionaRelatorio(tipo: string): void {
        this.botoesRelatorioRef.dismiss(tipo);
    }
}
